import { render, staticRenderFns } from "./PrincipalSearchPage.vue?vue&type=template&id=513fcdf8&scoped=true"
import script from "./PrincipalSearchPage.vue?vue&type=script&lang=js"
export * from "./PrincipalSearchPage.vue?vue&type=script&lang=js"
import style0 from "./PrincipalSearchPage.vue?vue&type=style&index=0&id=513fcdf8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513fcdf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('513fcdf8')) {
      api.createRecord('513fcdf8', component.options)
    } else {
      api.reload('513fcdf8', component.options)
    }
    module.hot.accept("./PrincipalSearchPage.vue?vue&type=template&id=513fcdf8&scoped=true", function () {
      api.rerender('513fcdf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/principal_search/PrincipalSearchPage.vue"
export default component.exports